import { Grid, Tooltip } from "@mui/material"
import React, { useContext } from "react"
import { customPalette } from "../../../../../../../../../../../theme"
import { NumberInput } from "../../../../../../../../../../components/inputs/number-input/NumberInput"
import { BooleanRadioButtonInput } from "../../../../../../../../../../components/inputs/radio-button-input/BooleanRadioButtonInput"
import { EnumRadioButton } from "../../../../../../../../../../components/inputs/radio-button-input/EnumRadioButton"
import { TypeCalculRadioButton } from "../../../../../../../../../../components/inputs/radio-button-input/TypeCalculRadioButton"
import { BaseSelectInput } from "../../../../../../../../../../components/inputs/select-input/BaseSelectInput"
import { NonEditableTextField } from "../../../../../../../../../../components/inputs/text-input/NonEditableTextField"
import {
  BuildingFacadeEnum,
  buildingFacadeEnumLabels,
} from "../../../../../../../../../../core/enum/beem-shot/BuildingFacadeEnum"
import {
  BuildingFrameEnum,
  buildingFrameEnumLabels,
} from "../../../../../../../../../../core/enum/beem-shot/BuildingFrameEnum"
import { FacadeCoverEnum, facadeCoverEnumLabels } from "../../../../../../../../../../core/enum/beem-shot/FacadeCoverEnum"
import { FloorCoverEnum, floorCoverEnumLabels } from "../../../../../../../../../../core/enum/beem-shot/FloorCoverEnum"
import { FloorTypeEnum, floorTypeEnumLabels } from "../../../../../../../../../../core/enum/beem-shot/FloorTypeEnum"
import { heatingTypeEnumLabels } from "../../../../../../../../../../core/enum/beem-shot/HeatingTypeEnum"
import { LoggiaEnum, loggiaEnumLabels } from "../../../../../../../../../../core/enum/beem-shot/LoggiaEnum"
import { isToiturePente, RoofEnum, roofEnumLabels } from "../../../../../../../../../../core/enum/beem-shot/RoofEnum"
import {
  RoofFlatCoverEnum,
  roofFlatCoverEnumLabels,
} from "../../../../../../../../../../core/enum/beem-shot/RoofFlatCoverEnum"
import {
  RoofSlopedCoverEnum,
  roofSlopedCoverEnumLabels,
} from "../../../../../../../../../../core/enum/beem-shot/RoofSlopedCoverEnum"
import { displayDecimal, enumToSelectOptions } from "../../../../../../../../../../core/services/helper-service"
import { BSMorphologyContext } from "../../../../../tabs/BSBuildingTabs/BSBuildingMorphologyTab/context/BSMorphologyContext"
import { SimplifiedQuestionnaireContext } from "../../SimplifiedQuestionnaireContext"
import DividerSimplifiedQuestionnaire from "./DividerSimplifiedQuestionnaire"

export function SimplifiedQuestionnaireMorpho(): React.JSX.Element {
  const { form, errors, handleChange } = useContext(SimplifiedQuestionnaireContext)
  const { bsMorphology } = useContext(BSMorphologyContext)

  return form.usage ? (
    <Grid container display="flex" justifyContent="flex-start" spacing={2} sx={{ pt: 2 }}>
      <Grid item xs={12}>
        <DividerSimplifiedQuestionnaire label="Dimensions de la zone" />
      </Grid>
      <Grid item xs={6}>
        <NonEditableTextField
          label="Surface utile ou SHAB (m²)"
          value={displayDecimal(bsMorphology?.surfaceRef, 2)}
          backgroundColor={customPalette.white}
        />
      </Grid>

      <Grid item xs={6}>
        <NonEditableTextField
          label="Surface plancher (m²)"
          value={displayDecimal(bsMorphology?.surfacePlancher, 2)}
          backgroundColor={customPalette.white}
        />
      </Grid>

      <Grid item xs={6}>
        <NonEditableTextField
          label="Emprise au sol (m²)"
          value={displayDecimal(bsMorphology?.empriseAuSol, 2)}
          backgroundColor={customPalette.white}
        />
      </Grid>

      <Grid item xs={6}>
        <NonEditableTextField
          label="Hauteur moyenne de la zone (m)"
          value={displayDecimal(bsMorphology?.averageHeightZone, 2)}
          backgroundColor={customPalette.white}
        />
      </Grid>

      <Grid item xs={12}>
        <DividerSimplifiedQuestionnaire label="Circulation verticale" />
      </Grid>

      <Tooltip title="Ajoutez les escaliers liés à l’usage sélectionné" arrow>
        <Grid item xs={12}>
          <NumberInput
            variant="outlined"
            id="nombreEscalier"
            label="Nombre de cages d'escaliers"
            mode="event"
            handleEventChange={handleChange}
            value={form.nombreEscalier}
            errors={errors}
            backgroundColor={customPalette.white}
            decimalScale={0}
          />
        </Grid>
      </Tooltip>

      <Tooltip title="Ajoutez les ascenseurs liés à l’usage sélectionné" arrow>
        <Grid item xs={12}>
          <NumberInput
            variant="outlined"
            id="nombreAscenseur"
            label="Nombre de cages d'ascenseurs"
            mode="event"
            handleEventChange={handleChange}
            value={form.nombreAscenseur}
            errors={errors}
            backgroundColor={customPalette.white}
            decimalScale={0}
          />
        </Grid>
      </Tooltip>

      <Grid item xs={12}>
        <DividerSimplifiedQuestionnaire label="Autres éléments" />
      </Grid>

      <Grid item xs={12} display="flex" alignItems="center">
        <BooleanRadioButtonInput
          filedName="balcons"
          label="Balcon"
          value={form.balcons}
          handleChange={(e) => handleChange(e)}
          errors={errors}
        />
      </Grid>

      {form.balcons && (
        <Grid item xs={6}>
          <NumberInput
            variant="outlined"
            backgroundColor="white"
            id="surfaceBalcons"
            label="Surface totale des balcons (m²)"
            mode="event"
            handleEventChange={handleChange}
            value={form.surfaceBalcons}
            errors={errors}
            margin="none"
          />
        </Grid>
      )}

      <Grid item xs={12} display="flex" alignItems="center">
        <BooleanRadioButtonInput
          filedName="loggias"
          label="Loggias"
          value={form.loggias}
          handleChange={(e) => handleChange(e)}
        />
      </Grid>
      {form.loggias && (
        <>
          <Grid item xs={6}>
            <BaseSelectInput
              id="typeLoggia"
              label="Type de loggia"
              selectedOption={form.typeLoggia}
              options={enumToSelectOptions(LoggiaEnum, loggiaEnumLabels)}
              mode="event"
              handleEventChange={(e) => handleChange(e)}
              isBeemShot
              errors={errors}
            />
          </Grid>
          <Grid item xs={6}>
            <NumberInput
              variant="outlined"
              backgroundColor="white"
              id="surfaceLoggias"
              label="Surface (m²)"
              mode="event"
              handleEventChange={handleChange}
              value={form.surfaceLoggias}
              errors={errors}
              margin="none"
            />
          </Grid>
        </>
      )}

      <Grid item xs={12}>
        <DividerSimplifiedQuestionnaire label="Structures et matériaux principaux" />
      </Grid>
      <Grid item xs={12}>
        <TypeCalculRadioButton id="typeCalcul" value={form.typeCalcul} handleChange={(e) => handleChange(e)} />
      </Grid>
      <Grid item xs={6}>
        <BaseSelectInput
          id="typeFacade"
          label="Façade"
          selectedOption={form.typeFacade}
          options={enumToSelectOptions(BuildingFacadeEnum, buildingFacadeEnumLabels)}
          mode="event"
          handleEventChange={(e) => handleChange(e)}
          isBeemShot
          errors={errors}
        />
      </Grid>

      <Grid item xs={6}>
        <BaseSelectInput
          id="typeToiture"
          label="Toiture et charpente"
          selectedOption={form.typeToiture}
          options={enumToSelectOptions(RoofEnum, roofEnumLabels)}
          mode="event"
          handleEventChange={(e) => handleChange(e)}
          isBeemShot
          errors={errors}
        />
      </Grid>

      <Grid item xs={6}>
        <BaseSelectInput
          id="typeSol"
          label="Plancher"
          selectedOption={form.typeSol}
          options={enumToSelectOptions(FloorTypeEnum, floorTypeEnumLabels)}
          mode="event"
          handleEventChange={(e) => handleChange(e)}
          isBeemShot
          errors={errors}
        />
      </Grid>
      <Grid item xs={6}>
        <BaseSelectInput
          id="typeOssature"
          label="Ossature"
          selectedOption={form.typeOssature}
          options={enumToSelectOptions(BuildingFrameEnum, buildingFrameEnumLabels)}
          mode="event"
          handleEventChange={(e) => handleChange(e)}
          isBeemShot
          errors={errors}
        />
      </Grid>

      {isToiturePente(form.typeToiture) ? (
        <Grid item xs={6}>
          <BaseSelectInput
            id="couvertureToiturePente"
            label="Revêtement de la toiture"
            selectedOption={form.couvertureToiturePente}
            options={enumToSelectOptions(RoofSlopedCoverEnum, roofSlopedCoverEnumLabels)}
            mode="event"
            handleEventChange={(e) => handleChange(e)}
            isBeemShot
            errors={errors}
          />
        </Grid>
      ) : (
        <Grid item xs={6}>
          <BaseSelectInput
            id="couvertureToiturePlate"
            label="Revêtement de la toiture"
            selectedOption={form.couvertureToiturePlate}
            options={enumToSelectOptions(RoofFlatCoverEnum, roofFlatCoverEnumLabels)}
            mode="event"
            handleEventChange={(e) => handleChange(e)}
            isBeemShot
            errors={errors}
          />
        </Grid>
      )}

      <Grid item xs={6}>
        <BaseSelectInput
          id="couvertureFacade"
          label="Revêtement de façade"
          selectedOption={form.couvertureFacade}
          options={enumToSelectOptions(FacadeCoverEnum, facadeCoverEnumLabels)}
          mode="event"
          handleEventChange={(e) => handleChange(e)}
          isBeemShot
          errors={errors}
        />
      </Grid>

      <Grid item xs={12}>
        <BaseSelectInput
          id="couvertureSol"
          label="Revêtement de sol"
          selectedOption={form.couvertureSol}
          options={enumToSelectOptions(FloorCoverEnum, floorCoverEnumLabels)}
          mode="event"
          handleEventChange={(e) => handleChange(e)}
          isBeemShot
          errors={errors}
        />
      </Grid>

      <Grid item xs={12}>
        <DividerSimplifiedQuestionnaire label="Durabilité et énergie" />
      </Grid>
      <Grid item xs={12}>
        <BooleanRadioButtonInput
          filedName="reseauChaleur"
          label="Réseau de chaleur"
          value={form.reseauChaleur}
          handleChange={(e) => handleChange(e)}
        />
      </Grid>
      <Grid item xs={12}>
        <EnumRadioButton
          id="typeChauffage"
          label="Chauffage"
          value={form.typeChauffage}
          options={heatingTypeEnumLabels}
          handleChange={(e) => handleChange(e)}
        />
      </Grid>
      <Grid item xs={12}>
        <BooleanRadioButtonInput
          filedName="recuperationEauPluie"
          label="Récupération des eaux pluviales"
          value={form.recuperationEauPluie}
          handleChange={(e) => handleChange(e)}
        />
      </Grid>
      <Grid item xs={12}>
        <BooleanRadioButtonInput
          filedName="photovoltaique"
          label="Photovoltaïque"
          value={form.photovoltaique}
          handleChange={(e) => handleChange(e)}
          disabled={form.photovoltaicDisabled}
        />
      </Grid>
      {form.photovoltaique && (
        <Grid item xs={6}>
          <NumberInput
            variant="outlined"
            backgroundColor="white"
            id="surfacePanneauPhotovoltaique"
            label="Surface de photovoltaïque (m²)"
            mode="event"
            handleEventChange={handleChange}
            value={form.surfacePanneauPhotovoltaique}
            errors={errors}
          />
        </Grid>
      )}
    </Grid>
  ) : (
    <div />
  )
}
